var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.059,
    height: 10,
    viewBox: "0 0 13.059 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Checkmark",
    d: "M23.424,13.377l-1.067-1.1a.229.229,0,0,0-.17-.073h0a.22.22,0,0,0-.17.073l-7.4,7.453-2.693-2.693a.234.234,0,0,0-.34,0l-1.079,1.079a.242.242,0,0,0,0,.346l3.4,3.4a1.074,1.074,0,0,0,.71.346,1.125,1.125,0,0,0,.7-.334h.006l8.108-8.15A.259.259,0,0,0,23.424,13.377Z",
    transform: "translate(-10.434 -12.206)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkWhite);
export default __webpack_public_path__ + "static/media/checkmarkWhite.76f997d6d47bbc66becd255d2dd3722b.svg";
export { ForwardRef as ReactComponent };